module.exports = __webpack_public_path__ + "img/kn_logo_standard_negative_rgb.0639196d.svg";